import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1F1E1D",
      "fill-rule": "evenodd",
      d: "M3.102 17V6.666A3.567 3.567 0 0 1 6.668 3.1h10.667a3.567 3.567 0 0 1 3.567 3.566v10.667a3.567 3.567 0 0 1-3.567 3.567H6.668a3.566 3.566 0 0 1-3.566-3.567zm1.8-10.334c0-.976.79-1.766 1.766-1.766h10.667c.976 0 1.767.79 1.767 1.766v5.42l-2.54-2.477a1.804 1.804 0 0 0-2.514 0l-3.44 3.355-.62-.606a1.804 1.804 0 0 0-2.515 0l-2.571 2.507zm14.2 7.935v2.732c0 .976-.791 1.767-1.767 1.767H6.668c-.96 0-1.742-.767-1.766-1.722l3.826-3.73h.003l1.248 1.217a.9.9 0 0 0 1.257 0l4.067-3.965h.003z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#1F1E1D",
      "fill-rule": "evenodd",
      d: "M7.598 7.598a1.275 1.275 0 1 1 1.804 1.804 1.275 1.275 0 0 1-1.804-1.804",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }